<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M16,5.094999914932251C16,2.839899914932251,14.1196,1.011699914932251,11.8,1.011699914932251C10.1176,1.011699914932251,8.6705,1.975699914932251,8,3.364399914932251C7.3295,1.975599914932251,5.8824,1.0116999149322516,4.2,1.0116999149322516C1.8804,1.0116999149322516,0,2.839799914932251,0,5.094999914932251C0,5.160699914932251,0.007,5.224599914932251,0.0101,5.289499914932251C0.0101,5.289499914932251,0.0036,5.289499914932251,0.0036,5.289499914932251C0.0051,5.335799914932251,0.0147,5.384999914932251,0.0175,5.431799914932251C0.0215,5.479499914932251,0.0257,5.526999914932251,0.0314,5.574299914932251C0.101,6.373799914932251,0.3524,7.237199914932251,0.8552,8.146499914932251C2.0732,10.354599914932251,4.2325,12.01799991493225,7.9998,14.999999914932252C11.767,12.01799991493225,13.9263,10.35339991493225,15.1443,8.146499914932251C15.6452,7.240699914932251,15.8963,6.380399914932251,15.9672,5.583599914932251C15.9739,5.529299914932251,15.9787,5.474699914932251,15.9832,5.419799914932251C15.9856,5.376999914932251,15.9946,5.331799914932251,15.9959,5.289399914932251C15.9959,5.289399914932251,15.99,5.289399914932251,15.99,5.289399914932251C15.993,5.224499914932251,16,5.160599914932251,16,5.094999914932251C16,5.094999914932251,16,5.094999914932251,16,5.094999914932251Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Heart',
} as DefineComponent
</script>
